import { User, Phone, Mail, Calendar, Pencil } from "lucide-react";

export default function ProfileHeader({ user, joinedText, onEdit }) {
  const initials = (user?.name || "?").trim().split(" ").map((s) => s[0]).slice(0, 2).join("").toUpperCase();
  return (
    <div className="bg-white rounded-3xl talabya-shadow-soft overflow-hidden" data-testid="profile-header">
      <div
        className="relative p-5 pb-8"
        style={{ background: "linear-gradient(135deg, #E05A3D 0%, #C5452A 100%)" }}
      >
        <div className="grain-overlay opacity-25"/>
        <div className="relative flex items-center justify-between gap-3">
          <div className="flex items-center gap-3 min-w-0">
            <div
              className="w-16 h-16 rounded-2xl flex items-center justify-center text-white font-black text-2xl ring-2 ring-white/40 shrink-0"
              style={{ background: "rgba(255,255,255,0.25)", fontFamily: "Cairo" }}
              data-testid="profile-avatar"
            >
              {initials}
            </div>
            <div className="text-white min-w-0">
              <div className="font-black text-lg truncate" style={{fontFamily:"Cairo"}} data-testid="profile-name">{user.name || "—"}</div>
              <div className="text-xs text-white/85">حساب زبون</div>
            </div>
          </div>
          <button
            onClick={onEdit}
            className="shrink-0 px-3 py-2 rounded-xl bg-white/95 text-primary-brand font-black text-xs flex items-center gap-1.5 hover:bg-white"
            data-testid="btn-edit-header">
            <Pencil size={13}/> تعديل
          </button>
        </div>
      </div>
      <div className="p-5 -mt-5 relative">
        <div className="bg-white rounded-2xl border border-[var(--border)] divide-y divide-[var(--border)]">
          <InfoRow icon={<Phone size={14}/>} label="رقم الهاتف" value={user.phone || "—"} dir="ltr" testId="row-phone"/>
          <InfoRow icon={<Mail size={14}/>}  label="البريد الإلكتروني" value={user.email || "غير مضبوط"} testId="row-email"/>
          <InfoRow icon={<Calendar size={14}/>} label="تاريخ الانضمام" value={joinedText || "—"} testId="row-joined"/>
          <InfoRow icon={<User size={14}/>} label="معرّف الزبون" value={(user.id || "").slice(0,8)} testId="row-uid"/>
        </div>
      </div>
    </div>
  );
}

function InfoRow({ icon, label, value, dir, testId }) {
  return (
    <div className="flex items-center gap-3 p-3" data-testid={testId}>
      <div className="w-8 h-8 rounded-lg bg-blue-50 text-primary-brand flex items-center justify-center shrink-0">
        {icon}
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-[11px] text-[var(--text-secondary)]">{label}</div>
        <div className="font-bold text-sm text-[var(--text-primary)] truncate" dir={dir}>{value}</div>
      </div>
    </div>
  );
}
